// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"7d3c33c2","393":"b5331ac6","445":"503c5770","554":"703ecb34","780":"e0988de1","876":"eb0cf2ac","974":"72a71fba"}[chunkId] + ".chunk.js";
};